import HomePageContentAPICall from "src/service/HomePageContentAPICall";
import BaseRepository from "./BaseRepository";

class HomePageContentRepository extends BaseRepository {
    getContentTabCount = async (searchParam) => {
        return await new HomePageContentAPICall().getContentTabCount({ searchParam })
    };
    getAllTabsCount = async (searchParam) => {
        return await new HomePageContentAPICall().getAllTabsCount(searchParam)
    };

    getAllContentList = async (page, limit, sort, searchParam) => {
        return await new HomePageContentAPICall().getAllContentList({ page, limit, sort, searchParam })
    }

    getAllContentVideoList = async (page, limit, searchParam) => {
        return await new HomePageContentAPICall().getAllContentVideoList({ page, limit, searchParam })
    }

    getArticleList = async (page, limit, sort, searchParam, filterList = []) => {
        return await new HomePageContentAPICall().getArticleContentList({ page, limit, sort, searchParam, filterList })
    }

    getVideoList = async (page, limit, sort, searchParam, filterList = []) => {
        return await new HomePageContentAPICall().getVideosList({ page, limit, sort, searchParam, filterList })
    }
    getNPIList = async (params) => { // 13142
        return await new HomePageContentAPICall().getNPIListBySearchParam(params.page, params.limit, params.sort, params.searchParam)

    }
}

export default HomePageContentRepository;